import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@material-ui/core";
import { createColumns, sortArrayNumProp } from "../../../redux/utils";
import { UnsortableList } from "../";
import { CustomGridProperties } from "../objects";

export const TabViewOqt = (props) => {

  const { details, section, name, caption, data, item, rootValues, order = "no_order", maxWidth = "md", variant = "outlined" } = props;
  const [ state, setState ] = useState(()=>({open: false, values: {}, list: item[name] ? sortArrayNumProp(item[name], order) : item[name]}));
  const [ fields, setFields ] = useState([]);

  useEffect(()=>{
    if(state.changeOrder>0){
      state.list.forEach(item =>
        data.editItem(item.id, item, section)
      )
    }
  }, [state.changeOrder])

  useEffect(() => {
    data.getSchema(section).then(response => {
      setFields(response.fields)
    })
  }, [])
  
  const handleChangeValues = (values) => {
  }

  const handleClose = () => {
    setState({...state, open: false});
  }

  const handleDetailsClick = ({row}, event) => {
    event && event.preventDefault();
    setState({...state, open: true, values: row});
  }

  const columns = createColumns({fields, disabled: details})({onDetails: handleDetailsClick});

  return (
    <div style={{margin: "8px"}}>
      {variant === "outlined" && caption}
      {!state.list || state.list.length === 0 
        ? <Typography variant="body1" padding={1}>No hay elementos para mostrar</Typography>
        : <UnsortableList   
            data={data}
            details={details}
            rows={state.list} 
            columns={columns}
          />
      }
      <Dialog fullWidth onClose={handleClose} open={state.open} keepMounted={false} maxWidth={maxWidth}>
        <DialogTitle>Detalles</DialogTitle>
        <DialogContent>
          <CustomGridProperties validationSchema={props.validationSchema && props.validationSchema.innerType} {...{data, name, item, fields: fields.map(field => ({...field, details: true})), rootValues}} initialValues={state.values} onChange={handleChangeValues} />
          <DialogContentText>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

}